







































import { Vue, Prop, Component } from 'vue-property-decorator';
import moment, { Moment } from 'moment';
import DateFormat from '../utils/date-format';

@Component({
  filters: {
    monthYear(value: string): string {
      const date: string = DateFormat.localDateToLocal(value);
      return DateFormat.fullMonthAndYear(date);
    },
  },
})
export default class DatePickerMonthYear extends Vue {
  @Prop({
    required: false,
    default: new Date().toISOString().substr(0, 7),
  })
  monthProp!: string;

  @Prop({
    required: false,
    default: false,
  })
  disabled!: boolean;

  @Prop({
    required: false,
  })
  rule!: any;

  @Prop({
    required: false,
    default: undefined,
  })
  label!: string;

  @Prop({
    required: false,
    default: 'Mês, ano',
  })
  placeholder!: string;

  @Prop({
    required: false,
    default: true,
  })
  dense!: boolean;

  @Prop() isAdministrator!: boolean;

  @Prop() isPaymentFilePage!: boolean;

  @Prop() isSupervisor!: boolean;

  @Prop() isJustificationModal!: boolean;

  @Prop({ type: Boolean, default: true }) clearable!: boolean;

  pickerMenu: boolean = false;

  get month() {
    return this.monthProp;
  }

  set month(value: string) {
    this.$emit('updateCompetence', value);
  }

  clearValue(): void {
    this.$emit('updateCompetence', '');
  }

  getDaysBetweenDates(startDate: Moment, endDate: Moment) {
    const now = startDate.clone();
    const dates: any = [];

    while (now.isSameOrBefore(endDate)) {
      dates.push(now.format('YYYY-MM'));
      now.add(1, 'months');
    }
    return dates;
  }

  disableMonths(val): boolean {
    if (this.isAdministrator && !this.isPaymentFilePage) {
      return this.disableSpecificMonths(val);
    }

    if (this.isJustificationModal || this.isSupervisor) {
      return this.disabledBeforeMonths(val);
    }

    return this.isPaymentFilePage;
  }

  disableSpecificMonths(val): boolean {
    const dateNow = moment();
    const numberOfMonthsToBeEnabled = 2;
    let startDate = dateNow.subtract(1, 'months');
    if (dateNow.date() >= 16) {
      startDate = moment();
    }
    const endDate = moment().add(numberOfMonthsToBeEnabled, 'months');
    let enableThisMonth = false;

    const dateList = this.getDaysBetweenDates(startDate, endDate);

    for (let i = 0; i < dateList.length; i += 1) {
      if (dateList[i] === val) {
        enableThisMonth = true;
      }
    }
    return enableThisMonth;
  }

  disabledBeforeMonths(val) {
    return val >= moment().subtract(1, 'months').format('YYYY-MM').substr(0, 10);
  }
}
